import { useQuery } from '@tanstack/react-query';
import axiosService from '../services/axios.service';
import { ApiResponse } from '../../../shared/types';

export interface PublicCrewInfo {
    name: string;
    slug: string;
    description: string;
    headerImage?: string;
    status: string;
    isPublic: boolean;
    autoJoin: boolean;
    memberCount?: number;
}

export const usePublicCrewInfo = (slug?: string) => {
    return useQuery({
        queryKey: ['public-crew-info', slug],
        queryFn: async () => {
            const response = await axiosService.get<ApiResponse<PublicCrewInfo>>(
                `/c/${slug}/info`
            );
            return response.data.data;
        },
        enabled: !!slug
    });
};
